import { CUSTOMER_FIELD_KEYS } from './api-config';
import { ReactNode } from 'react';
// PAGE TEXT CONSTANTS
export const CUSTOMER_PROFILES_TEXT = {
    pageTitle: 'Customer Profiles',
    pageDescription: 'Manage and view customer profiles',
    addButton: 'Add New Customer',
    editModalTitle: 'Edit Customer',
    viewModalTitle: 'View Customer',
    addModalTitle: 'New Customer',
    addButtonLabel: 'Create Customer',
    deleteModalTitle: 'Delete Customer',
    deleteDescription: 'Are you sure you want to delete',
    deleteWarning: 'This action cannot be undone.',
    deleteWarningTitle: 'Warning:',
    deleteWarningLines: [
        'All customer data will be permanently removed',
        'Booking history will be preserved but unlinked',
        'This action cannot be reversed'
    ],
    footerClose: 'Close',
    footerCancel: 'Cancel',
    footerDelete: 'Delete Customer',
    statsTitle: 'Customer Metrics',
};

// EMPTY STATE TEXT
export const CUSTOMER_EMPTY_STATE = {
    icon: 'ri-search-2-line',
    iconBgColor: 'bg-teal-100',
    iconColor: 'text-teal-600',
    title: 'Search Customer Profiles',
    description: 'Use the search filters above to find specific customers. You can search by name, email, customer ID, or apply various filters to narrow down results.',
    features: [
        { icon: 'ri-user-search-line', label: 'Search by Name' },
        { icon: 'ri-mail-line', label: 'Search by Email' },
        { icon: 'ri-hashtag', label: 'Search by ID' },
        { icon: 'ri-filter-3-line', label: 'Apply Filters' }
    ]
};

export const CUSTOMER_SEARCH_EMPTY_STATE = {
    title: 'No customers found',
    description: 'No customers match your current search criteria.',
    clearButton: 'Clear Filters & Search Again'
};

// AUTHORIZATION MODAL TEXT
export const CUSTOMER_AUTH_TEXT = {
    title: 'Authorization Required',
    getDescription: (fieldType: string) => `Enter code to reveal ${fieldType}`,
    privacyTitle: 'Privacy Protection',
    privacyDescription: 'Customer data is protected. Only authorized agents can view complete contact information.',
    codeLabel: 'Authorization Code',
    codePlaceholder: 'Enter authorization code',
    codeHelper: 'Demo code: 999999',
    cancelButton: 'Cancel',
    verifyButton: 'Verify & Reveal',
    verifyIcon: 'ri-lock-unlock-line',
    shieldIcon: 'ri-shield-check-line',
    closeIcon: 'ri-close-line',
    revealLabel: 'Reveal',
    hideLabel: 'Hide',
};

// MODAL CONFIGURATIONS
export const CUSTOMER_MODAL_TITLES: Record<string, (name: string) => string> = {
    add: () => CUSTOMER_PROFILES_TEXT.addModalTitle,
    delete: () => CUSTOMER_PROFILES_TEXT.deleteModalTitle,
    edit: (name: string) => `${CUSTOMER_PROFILES_TEXT.editModalTitle}: ${name}`,
    view: (name: string) => `${CUSTOMER_PROFILES_TEXT.viewModalTitle}: ${name}`,
};

export const CUSTOMER_MODAL_DESCRIPTIONS = {
    delete: (name: string) => (
        <>
            {CUSTOMER_PROFILES_TEXT.deleteDescription} <strong>{name}</strong>?
        </>
    ),
    auth: (type: 'email' | 'phone') => CUSTOMER_AUTH_TEXT.getDescription(type === CUSTOMER_FIELD_KEYS.email ? 'email address' : 'phone number'),
};

// Add this for the Delete Popup
export const CUSTOMER_DELETE_WARNING = {
    title: 'Warning:',
    items: [
        'All customer data will be permanently removed',
        'Booking history will be preserved but unlinked',
        'This action cannot be reversed'
    ]
};

// EMPTY STATE MESSAGES
export const CUSTOMER_TABLE_MESSAGES = {
    noData: 'No customers found',
    loading: 'Loading customers...',
    error: 'Failed to load customers',
};

export const CUSTOMER_MESSAGES = {
    auth: {
        maxAttemptsError: 'You have attempted maximum limits contact to admin',
        success: 'Identity verified successfully',
        failure: 'Failed to reveal data',
    },
    actions: {
        deleteSuccess: 'Customer deleted successfully',
        createSuccess: 'Customer created successfully',
        updateSuccess: 'Customer updated successfully',
        operationFailed: 'Operation failed',
    }
};

export const PAGINATION_LABELS = {
    previous: 'Previous',
    next: 'Next',
};

export const STATS_PERIOD_LABELS = {
    yesterday: 'from yesterday',
    lastWeek: 'from last week',
    lastMonth: 'from last month',
    lastYear: 'from last year',
};

export const INPUT_PLACEHOLDERS = {
    authCode: 'Enter 6-digit code',
    authCodeHelper: 'Admin Override Code: 999999',
    authFailed: 'Authentication Failed',
};
